import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue';
import appStore from '@/store';
import router from '@/router';
import { PLATFORM_IMAGES } from './config';
import { WHITE_LIST } from '@constants/intercept';

// const route = useRoute();

// watch(
//   () => route,
//   v => {
//     console.log('app router change', v);
//   },
//   { deep: true, immediate: true }
// );


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const baseHeight = ref('100vh');
const _setScale = () => {
  const screenWidth = window.innerWidth;
  const designWidth = screenWidth < 1200 ? 1200 : 1920;
  let scale = 1;

  if (screenWidth >= designWidth) {
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${window.innerWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = '100vh';
  } else {
    scale = screenWidth / designWidth;
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${designWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = `${window.innerHeight / scale}px`;
  }
};

/**
 * 创建favicon
 */
const createFavicon = () => {
  const link = (document.querySelector("link[rel*='icon']") ||
    document.createElement('link')) as any;
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = PLATFORM_IMAGES['favicon'];
  document.getElementsByTagName('head')[0].appendChild(link);
};

onMounted(() => {
  createFavicon();
  // 独立页（白名单，如 PC 答题）跳过主应用初始化调用链
  if (!WHITE_LIST.includes(router.currentRoute.value.path)) {
    appStore.useUserStoreSetup.initUserSystemData();
  }

  // setScale();
  // window.addEventListener('resize', setScale);
});
onUnmounted(() => {
  // window.removeEventListener('resize', setScale);
});

console.log('启动方式：', process.env.NODE_ENV);
console.log('启动环境：', process.env.VUE_APP_SCENE);
console.log('启动版本：', process.env.VERSION);
console.log('接口域名：', process.env.PROXY);
console.log('Cors：', process.env.DOMAIN);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    class: "router",
    style: _normalizeStyle({ width: '100%', height: baseHeight.value })
  }, null, 8, ["style"]))
}
}

})